import ConnectionsView from "@features/tools/view/connections-view";

const Connections = () => {
  return <ConnectionsView />;
};

export default Connections;
